import { useEffect, useRef, useState } from "react";
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { createSubCategory } from "../../../../store/slices/categories";
import CreatetableSelect from "react-select/creatable";
const CreateSubCategoryModal = ({ isOpen, toggle, pagination }) => {
  const serviceFormRef = useRef();
  const dispatch = useDispatch();
  const [formFields, setFormFields] = useState({
    name: "",
    description: "",
    slug_name: "",
    type: "grouped",
  });
  
  const {
    register,
    formState: { errors },
    setValue,
  } = useForm({ defaultValues: { name: "", description: "", type:"grouped" } });
  const [formFieldsValidation, setFormFieldsValidation] = useState({
    name: {
      ...register("name", { required: "This field is required" }),
    },
    description: {
      ...register("description", { required: "This field is required" }),
    },
    slug_name: {
      ...register("slug_name", { required: "This field is required" }),
    },
    type: {
      ...register("type", { required: "This field is required" }),
    },
  });
  const [typeOfBenefit, setTypeOfBenfefit] = useState([
    { value: "grouped", label: "Grouped" },
    { value: "individual", label: "Individual" },
  ]);

  useEffect(() => {}, []);

  const handleInput = (event, key) => {
    let value = event.target.value;
    if(key === "type"){
      setValue("type", event.value);
      setFormFields({ ...formFields, type: event.value });
    }
    if (key === "name") {
      setValue("slug_name", value.replaceAll(" ", "_"));
      setValue(key, value.replaceAll(" ", "_"));
      setFormFields({
        ...formFields,
        ["slug_name"]: value.replaceAll(" ", "_"),
        [key]: value,
      });
    } else {
      setValue(key, value);
      setFormFields({ ...formFields, [key]: value });
    }
  };

  const createCategoryData = async () => {
    let payload = {
      ...formFields,
    };

    let data = await dispatch(createSubCategory(payload));
    // console.log(data);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="m">
      <ModalHeader>Create Service Category</ModalHeader>
      <ModalBody>
        <div className="px-2">
          <div>
            <Label>Sub Category Name<span className="text-danger">*</span></Label>
            <Input
              name="name"
              type="text"
              placeholder="Enter service category name"
              value={formFields.name}
              {...formFieldsValidation.name}
              onChange={(event) => handleInput(event, "name")}  
              required
            />
            {errors.name && (
              <span className="mt-1 text-danger">{errors.name.message}</span>
            )}
          </div>
          <div className="mt-4">
            <Label>Sub Category Description<span className="text-danger">*</span></Label>
            <Input
              type="textarea"
              placeholder="Enter category description"
              {...formFieldsValidation.description}
              onChange={(event) => handleInput(event, "description")}
              required
            />
            {errors.description && (
              <span className="mt-1 text-danger">
                {errors.description.message}
              </span>
            )}
          </div>
          <div className="mt-4">
            <Label>Slug Name<span className="text-danger">*</span></Label>
            <Input
              name="slug name"
              type="text"
              placeholder="Enter slug name"
              value={formFields.slug_name}
              {...formFieldsValidation.slug_name}
              onChange={(event) => handleInput(event, "slug_name")}
              required
            />
            {errors.name && (
              <span className="mt-1 text-danger">{errors.name.message}</span>
            )}
          </div>

          <div className="mt-4">
            <Label>Select Benefit Type</Label>
           <CreatetableSelect
                  options={typeOfBenefit}
                  onChange={(event) => handleInput(event, "type")}
                  value={typeOfBenefit.find((x) => x.value === formFields.type)}
                />
            {errors.name && (
              <span className="mt-1 text-danger">{errors.name.message}</span>
            )}
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="d-flex customModalFooter">
        <button className="btn bg-primary" onClick={() => createCategoryData()}>
          Create
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CreateSubCategoryModal;
